import type { ReactNode } from "react";
import Divider from "../../components/ornaments/Divider.tsx";
import Feather from "../../components/ornaments/Feather.tsx";

type Props = {
  eyebrow: string;
  title: string;
  updatedAt: string;
  children: ReactNode;
};

export default function LegalPage({
  eyebrow,
  title,
  updatedAt,
  children,
}: Props) {
  return (
    <div className="mx-auto max-w-3xl px-6 py-16 md:px-10 md:py-24">
      <header
        className="relative mb-14 text-center"
        style={{ animation: "var(--animate-fade-up)" }}
      >
        <Feather
          className="pointer-events-none absolute top-1/2 left-1/2 h-40 w-auto -translate-x-1/2 -translate-y-1/2 opacity-[0.08]"
          aria-hidden
        />
        <div className="relative">
          <span className="eyebrow">{eyebrow}</span>
          <h1 className="mt-5 font-serif text-5xl leading-[1.05] text-[var(--color-emerald-deep)] md:text-6xl">
            {title}
          </h1>
          <p className="mt-4 text-[0.7rem] uppercase tracking-[0.22em] text-[var(--color-stone)]">
            Last updated · {updatedAt}
          </p>
        </div>
        <Divider className="mt-12" />
      </header>

      <article className="legal-body mx-auto max-w-2xl text-[var(--color-charcoal)]/85">
        {children}
      </article>
    </div>
  );
}
